import { Checkbox as AntCheckbox } from 'antd'
import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import type { T_CheckboxProps } from './checkbox'


export const SC_Checkbox = styled(
  (props: T_CheckboxProps) => <AntCheckbox {...props} />
)`
  font-size: 14px;
  line-height: 17px;
  gap: 8px;
  color: ${E_Colors.Gray3C3C4399};
  align-items: center;

  .ant-checkbox-wrapper {
    gap: 8px;
  }

  .ant-checkbox-label {
    padding: 0 !important;
  }

  .ant-checkbox-inner {
    width: 19px;
    height: 19px;
    border-radius: 4px;
    border: 1px solid ${E_Colors.SystemGrey3};

    background-color: ${E_Colors.White} !important;
  }

  &&:hover .ant-checkbox-inner,
  && .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${E_Colors.SystemGrey3} !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${E_Colors.MainColorAccent} !important;
    border-color: ${E_Colors.MainColorAccent} !important;
  }
`
